import { simpleEditNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { EditRowActionOptions } from '../../../../CIMSTableContext/types/actions/row'
import CreateEditFormItems from '../components/CreateEditFormItems'
import { EditFormItemsValues } from '../components/CreateEditFormItems/types'
import {
  Refetch,
  CimsQuickLinkEntity,
  EditCimsQuickLinkEntityOptions,
  Entity,
  MutationType,
} from '../types'

export function useEdit<Edit extends MutationType>({
  entity,
  mutation,
  permission,
  refetch,
  getLabel,
}: Entity &
  Refetch &
  EditCimsQuickLinkEntityOptions<Edit>): EditRowActionOptions<
  CimsQuickLinkEntity,
  EditFormItemsValues
> {
  const [edit] = mutation({
    ...DefaultMutationHookOptions,
    onCompleted: (edit) => simpleEditNotification(getLabel(edit).label),
  })
  return {
    permission,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems entity={entity} />,
      recordName: 'label',
      initialValues: ({ label, href, description }) => ({
        description,
        href,
        label,
      }),
      onOk: async ({ id, ...quickLink }, { description, href, label }) => {
        if (
          quickLink.description === description &&
          quickLink.href === href &&
          quickLink.label === label
        )
          return
        await edit({ variables: { input: { id, description, href, label } } })
        refetch()
      },
    },
  }
}
